<template>
  <v-card elevation="2">
    <v-card-title class="headline justify-center">
      Convênio
    </v-card-title>

    <v-card-text class="pt-4">
      <v-form ref="form" v-model="valido" lazy-validation>
        <p class="text-center mb-6">
          Defina o percentual de convênio concedido aos usuários dos aplicativos parceiros.
        </p>

        <v-layout justify-center>
          <v-flex xs12 sm8>
            <v-text-field
              v-model.lazy="percentual"
              label="Percentual de Convênio (%)"
              v-money="money"
              suffix="%"
              outlined
              dense
              :rules="[
                v => v !== null && v !== '' || 'Campo obrigatório',
                v => (typeof v === 'string' ? parseFloat(v.replace(',', '.')) : v) >= 0 || 'O valor não pode ser negativo'
              ]"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-card-actions class="pb-4 px-6">
      <v-btn color="grey" text @click="fechar">
        Cancelar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        rounded
        :loading="loading"
        @click="salvar"
        :disabled="!valido"
      >
        Salvar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { VMoney } from 'v-money'

export default {
  name: 'Configurar Convênio',
  directives: { money: VMoney },
  data () {
    return {
      valido: true,
      percentual: 0,
      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    empresa () {
      return this.$store.getters.empresa
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    fechar () {
      this.$emit('fechar')
    },
    salvar () {
      if (this.$refs.form.validate()) {
        const percentualFormatado = typeof this.percentual === 'string'
          ? this.percentual.split('.').join('').replace(',', '.')
          : this.percentual

        const payload = {
          cnpj: this.empresa.cnpj,
          percentual_convenio: parseFloat(percentualFormatado)
        }
        this.$store.dispatch('editarEmpresa', payload).then(() => {
          this.$store.dispatch('escolherEmpresa', this.empresa)
          this.fechar()
        })
      }
    }
  },
  mounted () {
    if (this.empresa && this.empresa.percentual_convenio) {
      this.percentual = this.empresa.percentual_convenio
    }
  }
}
</script>

<style scoped>
</style>
